import { Button } from '@/common/components/Button.tsx'
import LoadingCard from '@/common/components/LoadingCard.tsx'
import { FullCenteredMain } from '@/layouts/FullCenteredLayout.tsx'
import { useTranslation } from 'react-i18next'
import { InfoCircleIcon } from '@/app/common/icons/general'
import { BlackArrowRightIcon } from '@/common/icons/arrows.tsx'
import { z } from 'zod'

export const NoAccessPage = () => {
  const { t: translate } = useTranslation()
  const snowApplicantUrl = import.meta.env.VITE_SNOW_APPLICANT_URL
  const isUrlValid = z.string().url().safeParse(snowApplicantUrl).success

  return (
    <FullCenteredMain>
      <LoadingCard>
        <div className="flex flex-col items-center text-center">
          <InfoCircleIcon className="text-7xl text-blue-500 mb-4" />
          <h1 className="text-2xl font-bold mb-2">
            {translate('no_access_title', {
              defaultValue: 'Finish Your Application',
            })}
          </h1>
          <p className="mb-8 text-base text-gray-500 font-normal max-w-md">
            {translate('no_access_description', {
              defaultValue:
                "It looks like you haven't completed your scholarship application. To access this site, please finish your application on our application portal.",
            })}
          </p>
          <Button
            size="lg"
            disabled={!isUrlValid}
            onClick={() => {
              if (isUrlValid) {
                window.location.replace(snowApplicantUrl)
              }
            }}
          >
            {translate('finish_registration', {
              defaultValue: 'Finish Registration',
            })}
            <BlackArrowRightIcon className="ml-2" />
          </Button>
        </div>
      </LoadingCard>
    </FullCenteredMain>
  )
}
